export default __webpack_public_path__ + "static/image-API-q&a-08536878ea1a01f79f3f7a9c15142be0.png";